export default [
  {
    path: 'post',
    name: 'post',
    component: () => import('@/views/pages/post/Post.vue'),
    meta: {
      pageTitle: 'Post',
      breadcrumb: [
        {
          text: 'Post',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
  {
    path: 'post/create',
    name: 'post-create',
    component: () => import('@/views/pages/post/Update.vue'),
    meta: {
      pageTitle: 'Create',
      breadcrumb: [
        {
          to: { name: 'post' },
          text: 'Posts',
          active: false,
        },
        {
          text: 'Create',
          active: true,
        },
      ],
      resource: 'All',
      page: 'create',
    },
  },
  {
    path: 'post/update/:id',
    name: 'post-update',
    component: () => import('@/views/pages/post/Update.vue'),
    meta: {
      pageTitle: 'Update',
      breadcrumb: [
        {
          to: { name: 'post' },
          text: 'Posts',
          active: false,
        },
        {
          text: 'Update',
          active: true,
        },
      ],
      resource: 'All',
      page: 'update',
    },
  },
  {
    path: 'post/:id',
    name: 'post-view',
    component: () => import('@/views/pages/post/View.vue'),
    meta: {
      pageTitle: 'View',
      breadcrumb: [
        {
          to: { name: 'post' },
          text: 'Posts',
          active: false,
        },
        {
          text: 'View',
          active: true,
        },
      ],
      resource: 'All',
      page: 'back',
    },
  },
]
